import React, {createContext, useState} from "react"

const ShowContext = createContext()
export default ShowContext;

export const ShowProvider = ({children}) => {
        const [englishText, setEnglishText] = useState("")
        const [persianText, setPersianText] = useState("")
        const [isRendered, setIsRendered] = React.useState({
        main: true,
        addNewDocumentForm: false,
        addNewPageForm: false,
        editPageForm: false,
        showPagePanel: false,
        login: false,
        allDocuments: false,
        recentDocuments: true,
    })


    function showAddNewDocumentClick() {
        hideAll()
      setIsRendered(prevState => ({
        ...prevState,
        addNewDocumentForm: true
      }));
    }

    function hideAddNewDocumentClick(){
      setIsRendered(prevState => ({
        ...prevState,
        addNewDocumentForm: false
      }));
    }


    function showAddNewPageClick(documentId, documentName) {
      setIsRendered(prevState => ({
        ...prevState,
          addNewPageForm: true,
        documentId: documentId,
        documentName:documentName
      }));
    }

    function showEditPageClick(documentId, documentName) {
      setIsRendered(prevState => ({
        ...prevState,
          editPageForm: true,
        documentId: documentId,
        documentName:documentName
      }));
    }
    function hideEditPageClick() {
      setIsRendered(prevState => ({
        ...prevState,
          editPageForm: false,
        // documentId: documentId,
        // documentName:documentName
      }));
    }

    function hideAddNewPageClick(){
      setIsRendered(prevState => ({
        ...prevState,
        addNewPageForm: false
      }));
      setEnglishText("")
      setPersianText("")

    }

    function showLogin() {
    setIsRendered(prevState => ({
        ...prevState,
        login: true
    }));
    }


    function hideLogin() {
    setIsRendered(prevState => ({
        ...prevState,
        login: false
    }));
    }

    function hideMain() {
    setIsRendered(prevState => ({
        ...prevState,
        main: false
    }));
    }



    function hideAll(){
        const newIsRendered ={}
        for (const k in isRendered){
            newIsRendered[k] = false
        }
        setIsRendered(newIsRendered)
    }

    function showPage(){
     setIsRendered(prevState => ({
        ...prevState,
        showPagePanel: true
    }));
    }

    function showAllDocumentsDiv(){
     setIsRendered(prevState => ({
        ...prevState,
        allDocuments: true
    }));
    }

        function hideAllDocumentsDiv(){
     setIsRendered(prevState => ({
        ...prevState,
        allDocuments: false
    }));
    }

    let contextData = {
        isRendered:isRendered,
        showAddNewDocumentClick:showAddNewDocumentClick,
        hideAddNewDocumentClick:hideAddNewDocumentClick,
        showAddNewPageClick:showAddNewPageClick,
        hideAddNewPageClick:hideAddNewPageClick,
        showLogin:showLogin,
        hideLogin:hideLogin,
        hideAll:hideAll,
        showPage:showPage,
        showAllDocumentsDiv:showAllDocumentsDiv,
        hideAllDocumentsDiv:hideAllDocumentsDiv,
        englishText:englishText,
        setEnglishText:setEnglishText,
        persianText:persianText,
        setPersianText:setPersianText,
        showEditPageClick:showEditPageClick,
        hideEditPageClick:hideEditPageClick,
        hideMain:hideMain,
        }
    return(
        <ShowContext.Provider value={contextData}>
            {children}
        </ShowContext.Provider>
    )

}